// apps/client/src/engine/quality.ts — two render presets; players override the automatic choice in settings (M1-T18)
import { tuning } from '@whiskerton/content';
export type QualityLevel = 'low' | 'high';
export interface QualityPreset { maxDpr: number; shadows: boolean; gtao: boolean; maxScale: number }
export const QUALITY: Readonly<Record<QualityLevel, QualityPreset>> = {
  low: { maxDpr: 1.5, shadows: false, gtao: false, maxScale: 1 },
  high: { maxDpr: tuning.render.maxDpr, shadows: true, gtao: true, maxScale: 1 },   // D-36: GTAO only here
};
export function resolveQuality(setting: 'auto' | 'low' | 'high', d: { coarse: boolean; cores: number; memoryGb: number | null }): QualityLevel {
  if (setting !== 'auto') return setting;
  if (d.coarse) return 'low';                                         // phones: no GTAO/shadow maps; dynamic resolution holds 60 fps
  return d.cores >= 4 && (d.memoryGb === null || d.memoryGb >= 4) ? 'high' : 'low';
}
